export default (filter, row) => {
  const { id, value } = filter;
  if (row[id]) {
    const text = row[id].toString().toUpperCase();
    const search = value.toUpperCase();
    return text.includes(search);
  }
  return null;
};
